import { render, staticRenderFns } from "./_bulk_delete_products_modal.vue?vue&type=template&id=2c663047&"
import script from "./_bulk_delete_products_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_delete_products_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports